// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3xK8C","alert":"SettungsInbox_alert__2lstr"};